import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import {loadFirebase} from './../actions/appActions';
import {Loader, Dimmer} from 'semantic-ui-react';
import AppRoutes from './screens/AppRoutes';

class Givr extends React.Component {

    constructor(props){
        super(props);

    }
    componentWillMount(){
        this.props.loadFirebase();
    }
    
    componentDidMount(){


    }

    render(){
        if(!this.props.connected || !this.props.authChecked) {
            return (
                <Dimmer inverted active>
                    <Loader>Loading</Loader>
                </Dimmer>
            )
        }

        return (
            <AppRoutes />
        )
    }
}

Givr.propTypes = {
    
}

const mapStateProps = (state) => {
    return {
        connected : state.app.connected,
        connecting : state.app.connecting,
        authedUser : state.app.authedUser,
        authChecked : state.app.authChecked
    };
}

export default  connect(mapStateProps, { loadFirebase })(Givr);



// WEBPACK FOOTER //
// ./src/components/Givr.js